import React, { createContext, useReducer, useContext, useCallback } from 'react';
import { createCheckoutSession, createPortalSession } from '../services/subscriptionService';
import { UIContext } from './UIContext';

const initialState = {
  subscription: null,
  credits: 0,
  loading: false,
  error: null
};

const subscriptionReducer = (state, action) => {
  switch (action.type) {
    case 'SUBSCRIPTION_START':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'SUBSCRIPTION_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

const SubscriptionContext = createContext(initialState);

export const SubscriptionProvider = ({ children }) => {
  const [state, dispatch] = useReducer(subscriptionReducer, initialState);
  const { showAlert } = useContext(UIContext);

  const initiateSubscription = useCallback(async (planId) => {
    dispatch({ type: 'SUBSCRIPTION_START' });
    try {
      const checkoutUrl = await createCheckoutSession(planId);
      window.location.href = checkoutUrl;
    } catch (error) {
      dispatch({ type: 'SUBSCRIPTION_ERROR', payload: error.message });
      showAlert(error.message, 'error');
    }
  }, [showAlert]);

  const manageSubscription = useCallback(async () => {
    try {
      const portalUrl = await createPortalSession();
      window.location.href = portalUrl;
    } catch (error) {
      showAlert(error.message, 'error');
    }
  }, [showAlert]);

  const value = {
    ...state,
    initiateSubscription,
    manageSubscription
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};
